import { useEffect } from 'react';

/** Adds `.visible` to every `.fade-in-up` element on the page as it scrolls into view. */
const useFadeIn = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.fade-in-up:not(.visible)').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
};

export default useFadeIn;
